import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import {
    defaultFixedAssetsSettingCategory, defaultFixedAssetsSettingPercTable,
    setFixedAssetsSettings, setFixedAssetsSettingsSelectedCategory
} from "../../../../_reducers/DataPanel/FixedAssets/fixedAssetsSlice";
import BetterCheckBox from "../../../common/BetterCheckBox";
import EditableTable from "../../../primer/Editable-Table";
import {
    checkPermissionMasterParentStartingTree,
    isEmpty,
    startingPeriodOptions
} from "../../../../_helpers/commonFunctions";
import {setSaveFixedAssetsSettings} from "../../../../_reducers/activitySlice";
import {fetchFixedAssetsSettings} from "../../../../_apis/api";
import LogTable from "../../../primer/LogTable";
import Input from "../../../common/Input";
import {DISABLED_FIXED_ASSET_CATEGORIES} from "./constants";
import {useTranslation} from "../../../../hooks/useTranslation";

const FixedAssetsSettings = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const saveFixedAssetsSettings = useSelector((state) => state.ACTIVITY.saveFixedAssetsSettings);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);
    const fixedAssetsSettingsSelectedCategory = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettingsSelectedCategory); // index of selected category

    const selectedCategory = fixedAssetsSettingsSelectedCategory >= 0 ? fixedAssetsSettings.categories[fixedAssetsSettingsSelectedCategory] : null;
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    useEffect(() => {
        dispatch(fetchFixedAssetsSettings(company.id));
    }, [])

    const tableColumns = [
        {
            name: "Όνομα Κατηγορίας",
            field: "name",
            editable: true,
            disabledCallback: (rowData) => DISABLED_FIXED_ASSET_CATEGORIES.includes(rowData.name),
            width: "70%",
            inputType: {
                type: "input",
            }
        },
        {
            name: "Πρόθεμα",
            field: "maskCode",
            editable: true,
            width: "30%",
            inputType: {
                type: "input",
            }
        }
    ]

    const percentageTableColumns = [
        {
            name: "Ετήσιο % απόσβεσης",
            field: "percentage",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
            }
        },
        {
            name: "Αριθμός μηνός από",
            field: "monthFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                }
            }
        },
        {
            name: "Αριθμός μηνός έως",
            field: "monthTo",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                }
            }
        },
        {
            name: "Αξία από",
            field: "amountFrom",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                }
            }
        },
        {
            name: "Αξία έως",
            field: "amountTo",
            editable: true,
            required: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "nosuffix",
                }
            }
        },
    ]

    const myDataColumns = [
        {
            name: t('ProductsNewGeneral.table.rowType'),
            field: "rowType",
            width: "15%",
            editable: true,
            inputType: {
                type: 'select',
                options: [{
                    value: "expense",
                    label: "Έξοδα"
                }]
            }
        },
        {
            name: t('ProductsNewGeneral.table.invoiceType'),
            field: "invoiceType",
            editable: true,
            width: "35%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.category'),
            field: "category",
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        {
            name: t('ProductsNewGeneral.table.type'),
            field: 'type',
            editable: true,
            width: "25%",
            inputType: {
                type: 'select',
                options: [],
            }
        },
        /*
        {
            name: t('ProductsNewGeneral.table.vatExpenseType'),
            field: 'vatExpenseType',
            editable: true,
            width: "20%",
            inputType: {
                type: 'select',
                options: getVatExpenseClassificationType(),
            }
        }
         */
    ];

    const handleOnChangeCategory = (e, type, name) => {
        if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "cb") {
            prepChange[name] = e.target.checked;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        }
        const cloneCategories = structuredClone(fixedAssetsSettings.categories);
        cloneCategories[fixedAssetsSettingsSelectedCategory] = {...cloneCategories[fixedAssetsSettingsSelectedCategory], ...prepChange};
        dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
    }

    const categoryTableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value)) {
                if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
                const newOne = {...defaultFixedAssetsSettingCategory, [data.field] : data.value}
                if (data.field === "name") {
                    const sliceIt = String(data.value).slice(0, 3);
                    newOne.maskCode = `${sliceIt}-****`;
                }
                const cloneCategories = fixedAssetsSettings.categories.slice();
                cloneCategories.push(newOne);
                dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[rowIndex] = {...cloneCategories[rowIndex], ...data};
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        },
        selected: (id, rowIndex) => {
            dispatch(setFixedAssetsSettingsSelectedCategory(rowIndex));
        },
        delete: (id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const cloneCategories = fixedAssetsSettings.categories.slice();
            cloneCategories.splice(rowIndex, 1);
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        },
    }

    const percentageTableFunctions = {
        insert: (e, data) => {
            if (!isEmpty(data.value) && +data.value > 0) {
                if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
                const newOne = {...defaultFixedAssetsSettingPercTable, [data.field] : data.value};
                const clonePercTable = structuredClone(selectedCategory.percentageTable);
                clonePercTable.push(newOne);

                const cloneCategories = structuredClone(fixedAssetsSettings.categories);
                cloneCategories[fixedAssetsSettingsSelectedCategory].percentageTable = clonePercTable;
                dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const clonePercTable = structuredClone(selectedCategory.percentageTable);
            clonePercTable[rowIndex] = {...clonePercTable[rowIndex], ...data};

            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[fixedAssetsSettingsSelectedCategory].percentageTable = clonePercTable;
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const clonePercTable = structuredClone(selectedCategory.percentageTable);
            clonePercTable.splice(rowIndex, 1);

            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[fixedAssetsSettingsSelectedCategory].percentageTable = clonePercTable;
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        }
    }

    const myDataFunctions = {
        insert: (e, data) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const cloneMD = structuredClone(selectedCategory.mydata || []);
            const newOne = {
                rowType: "",
                invoiceType: "",
                category: "",
                type: "",
                vatExpenseType: "",
            }
            newOne[data.field] = data.value;
            cloneMD.push(newOne);

            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[fixedAssetsSettingsSelectedCategory].mydata = cloneMD;
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        },
        update: (data, id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const cloneMD = structuredClone(selectedCategory.mydata);
            cloneMD[rowIndex] = {...cloneMD[rowIndex], ...data};
            if (data.invoiceType) {
                cloneMD[rowIndex].category = "";
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.category) {
                cloneMD[rowIndex].type = "";
                cloneMD[rowIndex].vatExpenseType = "";
            } else if (data.type) {
                cloneMD[rowIndex].vatExpenseType = "";
            }
            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[fixedAssetsSettingsSelectedCategory].mydata = cloneMD;
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveFixedAssetsSettings) dispatch(setSaveFixedAssetsSettings(true));
            const cloneMD = structuredClone(selectedCategory.mydata);
            cloneMD.splice(rowIndex, 1);
            const cloneCategories = structuredClone(fixedAssetsSettings.categories);
            cloneCategories[fixedAssetsSettingsSelectedCategory].mydata = cloneMD;
            dispatch(setFixedAssetsSettings({...fixedAssetsSettings, categories: cloneCategories}));
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={6}>
                    <EditableTable
                        tableName={"Fixed Assets Categories"}
                        key={Math.random()}
                        columns={tableColumns}
                        onUpdate={categoryTableFunctions}
                        data={fixedAssetsSettings?.categories ? fixedAssetsSettings.categories : []}
                        allowInsertRow={true}
                        allowActions={true}
                        selectedRow={fixedAssetsSettingsSelectedCategory}
                        handleAfterDelete={() => dispatch(fetchFixedAssetsSettings(company.id))}
                    />
                </Col>
            </Row>
            {selectedCategory && (
                <React.Fragment>
                    <hr />
                    <div style={{textAlign: "center", fontWeight: "600", fontSize: "24px"}}>Ρυθμίσεις Κατηγορίας: {selectedCategory.name}</div>
                    <Row>
                        <Col md={3}>
                            <Dropdown
                                name={"startingPeriod"}
                                label={"Περίοδος έναρξης"}
                                options={startingPeriodOptions}
                                defaultValue={startingPeriodOptions.find((el) => el.value === selectedCategory.startingPeriod)}
                                key={selectedCategory.startingPeriod}
                                onChange={(e) => handleOnChangeCategory(e, "dd", "startingPeriod")}
                            />
                        </Col>
                        <Col md={3}>
                            <div style={{marginTop: "33px"}}>
                                <BetterCheckBox
                                    name={"vatIsIncluded"}
                                    text={"Ο Φ.Π.Α. αποσβένεται"}
                                    checked={selectedCategory.vatIsIncluded}
                                    onChange={(e) => handleOnChangeCategory(e, "cb", "vatIsIncluded")}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <EditableTable
                                tableName={"Fixed Assets Category Percentage Table"}
                                key={Math.random()}
                                columns={percentageTableColumns}
                                onUpdate={percentageTableFunctions}
                                data={selectedCategory?.percentageTable ? selectedCategory.percentageTable : []}
                                allowInsertRow={true}
                                allowActions={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <div className="text-muted mb-2"><i>My Data</i></div>
                        <EditableTable
                            tableName="New Fixed Asset My Data"
                            key={Math.random()}
                            allowActions={true}
                            onUpdate={myDataFunctions}
                            allowInsertRow={true}
                            columns={myDataColumns}
                            enableNewRowCheckbox={true}
                            data={selectedCategory.mydata || []}
                        />
                    </Row>
                    {checkPermissionMasterParentStartingTree("accounting", permissionsData) === true && (
                        <React.Fragment>
                            <hr/>
                            <p className="text-muted"><i>Ρυθμίσεις Λογιστικής</i></p>
                            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αποσβέσεις - Κινήσεις Παγίων</i></div>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"accounting"}
                                        label={"Πρόθεμα Λογιστικής Γέφυρας"}
                                        value={selectedCategory?.accounting || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "accounting")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"bypassAccounting"}
                                        label={"Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                                        value={selectedCategory?.bypassAccounting || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "bypassAccounting")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"inverseAccounting"}
                                        label={"Πρόθεμα Αντισυμβαλλόμενου Κωδικού Λογιστικής"}
                                        value={selectedCategory?.inverseAccounting || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "inverseAccounting")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"bypassInverseAccounting"}
                                        label={"Αντισυμβαλλόμενος Κωδικός Παράκαμψης Λογιστικής Γέφυρας"}
                                        value={selectedCategory?.bypassInverseAccounting || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "bypassInverseAccounting")}
                                    />
                                </Col>
                            </Row>

                            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Αγορές Παγίων</i></div>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"accountingCodeBuys"}
                                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                        value={selectedCategory?.accountingCodeBuys || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "accountingCodeBuys")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"netAmountAccountingCodeBuys"}
                                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                                        value={selectedCategory?.netAmountAccountingCodeBuys || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "netAmountAccountingCodeBuys")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"vatAccountingCodeBuys"}
                                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                                        value={selectedCategory?.vatAccountingCodeBuys || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "vatAccountingCodeBuys")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"taxAccountCodeBuys"}
                                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                                        value={selectedCategory?.taxAccountCodeBuys || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "taxAccountCodeBuys")}
                                    />
                                </Col>
                            </Row>

                            <div className="text-muted mb-2"><i>Ρυθμίσεις Λογιστικής για Πωλήσεις Παγίων</i></div>
                            <Row className={"mb-2"}>
                                <Col md={3}>
                                    <Input
                                        name={"accountingCodeSales"}
                                        label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                        value={selectedCategory?.accountingCodeSales || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "accountingCodeSales")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"netAmountAccountingCodeSales"}
                                        label={"Κωδικός Λογαριασμού Παράκαμψης Καθαρής Αξίας"}
                                        value={selectedCategory?.netAmountAccountingCodeSales || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "netAmountAccountingCodeSales")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"vatAccountingCodeSales"}
                                        label={"Κωδικός Λογαριασμού Παράκαμψης ΦΠΑ"}
                                        value={selectedCategory?.vatAccountingCodeSales || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "vatAccountingCodeSales")}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Input
                                        name={"taxAccountCodeSales"}
                                        label={"Κωδικός λογαριασμού Παράκαμψης Φόρου"}
                                        value={selectedCategory?.taxAccountCodeSales || ""}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChangeCategory(e, "input", "taxAccountCodeSales")}
                                    />
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export const FixedAssetsSettingsLog = () => {
    const fixedAssetsSettings = useSelector((state) => state.FIXED_ASSETS.fixedAssetsSettings);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>Ιστορικό ρυθμίσεων αποσβέσεων</i></div>
            <LogTable itemId={fixedAssetsSettings._id}/>
        </React.Fragment>
    )
}

export default FixedAssetsSettings;
